import { render, staticRenderFns } from "./langSelectedBlock.vue?vue&type=template&id=53e7473b&scoped=true"
import script from "./langSelectedBlock.vue?vue&type=script&lang=js"
export * from "./langSelectedBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e7473b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e7473b')) {
      api.createRecord('53e7473b', component.options)
    } else {
      api.reload('53e7473b', component.options)
    }
    module.hot.accept("./langSelectedBlock.vue?vue&type=template&id=53e7473b&scoped=true", function () {
      api.rerender('53e7473b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/btn/lang/langSelectedBlock.vue"
export default component.exports